var map = {
	"./image-banner-information.png": 7443,
	"./logo-guia-de-marcas.png": 185,
	"./logo-guia-de-marcas.svg": 142,
	"./monitor-de-marcas-logo.svg": 7182,
	"./monitor-de-marcas-v2.svg": 9178,
	"./new-logo-monitor.png": 5215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;